"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _lodash = require("lodash");

var _gatsby = require("gatsby");

var _Layout = _interopRequireDefault(require("./Layout"));

var _BlogRoll = _interopRequireDefault(require("../columns/BlogRoll"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var TagRoute =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TagRoute, _React$Component);

  var _super = _createSuper(TagRoute);

  function TagRoute() {
    (0, _classCallCheck2["default"])(this, TagRoute);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TagRoute, [{
    key: "render",
    value: function render() {
      var posts = this.props.data.allMarkdownRemark.edges;
      var langKey = this.props.pageContext.langKey;
      var tag = this.props.pageContext.tag;
      var defaultLangKey = this.props.data.markdownRemark.frontmatter.defaultLangKey;
      var tagList = this.props.data.markdownRemark.frontmatter.tagList;
      var tagDef = tagList.filter(function (tagList) {
        return (0, _lodash.toUpper)(tagList.tag) === (0, _lodash.toUpper)(tag);
      });
      var overrideDefaultLangKey = tagDef.map(function (tagList) {
        return tagList.overrideDefaultLangKey;
      });
      var finalDefaultLangKey = overrideDefaultLangKey[0] !== null && overrideDefaultLangKey[0] !== "" ? overrideDefaultLangKey : defaultLangKey;
      var translation = tagDef.map(function (tagList) {
        return tagList.translations.filter(function (translation) {
          return translation.langKey === langKey;
        }).map(function (translation) {
          return translation.tagDisplay;
        });
      });
      var longDesc = tagDef.map(function (tagList) {
        return tagList.translations.filter(function (translation) {
          return translation.langKey === langKey;
        }).map(function (translation) {
          return translation.longDesc;
        });
      });
      var defTranslation = tagDef.map(function (tagList) {
        return tagList.translations.filter(function (translation) {
          return translation.langKey === finalDefaultLangKey;
        }).map(function (translation) {
          return translation.tagDisplay;
        });
      });
      var defLongDesc = tagDef.map(function (tagList) {
        return tagList.translations.filter(function (translation) {
          return translation.langKey === finalDefaultLangKey;
        }).map(function (translation) {
          return translation.longDesc;
        });
      });
      var finTranslation = translation[0][0] !== null && translation[0][0] !== "" ? translation : defTranslation;
      var finLongDesc = longDesc[0][0] !== null && longDesc[0][0] !== "" ? longDesc : defLongDesc;
      var title = this.props.data.site.siteMetadata.title;
      var totalCount = this.props.data.allMarkdownRemark.totalCount;
      var tagHeader = "".concat(totalCount, " post").concat(totalCount === 1 ? '' : 's', " tagged with \u201C").concat(finTranslation, "\u201D");
      var slug = langKey === 'en' ? "/tags/".concat(tag) : "".concat(langKey, "/tags/").concat(tag);
      var tagsLink = langKey === 'en' ? "/all-tags" : "".concat(langKey, "/all-tags");
      return (
        /*#__PURE__*/
        _react["default"].createElement(_Layout["default"], {
          langKey: "".concat(langKey),
          slug: "".concat(slug)
        },
        /*#__PURE__*/
        _react["default"].createElement("section", {
          className: "hero is-small is-fullheight",
          style: {
            padding: this.props.padding,
            display: 'block'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_reactHelmet["default"], {
          title: "".concat(tag, " | ").concat(title)
        }),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "hero-body"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "container content"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "columns"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "column is-10 is-offset-1",
          style: {
            marginBottom: '6rem'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("h3", {
          className: "title is-size-9 is-bold-light"
        }, tagHeader),
        /*#__PURE__*/
        _react["default"].createElement("p", null, finLongDesc),
        /*#__PURE__*/
        _react["default"].createElement(_BlogRoll["default"], {
          langKey: langKey,
          isTags: true,
          data: posts
        }),
        /*#__PURE__*/
        _react["default"].createElement("div", null, tagDef && tagDef.map(function (tag) {
          return (
            /*#__PURE__*/
            _react["default"].createElement("div", null, tag.children !== null &&
            /*#__PURE__*/
            _react["default"].createElement("div", {
              style: {
                paddingBottom: '1rem'
              }
            },
            /*#__PURE__*/
            _react["default"].createElement("h3", {
              className: "title is-size-9 is-bold-light"
            }, "Child Tags:"),
            /*#__PURE__*/
            _react["default"].createElement("ul", null, tag.children && tag.children.map(function (child) {
              return (
                /*#__PURE__*/
                _react["default"].createElement("li", null,
                /*#__PURE__*/
                _react["default"].createElement(_gatsby.Link, {
                  to: child
                },
                /*#__PURE__*/
                _react["default"].createElement("p", null, child)))
              );
            }))))
          );
        })),
        /*#__PURE__*/
        _react["default"].createElement("p", null,
        /*#__PURE__*/
        _react["default"].createElement(_gatsby.Link, {
          to: "".concat(tagsLink)
        }, "Browse all tags"))))))))
      );
    }
  }]);
  return TagRoute;
}(_react["default"].Component);

var _default = TagRoute;
exports["default"] = _default;